var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "mini",
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("desresetbutton.text"), prop: "text" } },
            [
              _c("el-input", {
                attrs: { maxlength: "10", "show-word-limit": "" },
                model: {
                  value: _vm.currentElement.options.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentElement.options, "value", $$v)
                  },
                  expression: "currentElement.options.value",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sure } },
                [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("commons.cancel"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }